import { connect } from 'react-redux'
import { rotateFrame } from '../../actions/project/frame'
import { IconElement } from '../../components/FrameMenu/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(rotateFrame()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/Rotate.js